export default "/_next/static/chunks/fonts/WaitingfortheSunrise-Regular-a500971518a7b73dacd44671a16f67a3.woff2";